import { createAsyncThunk } from "@reduxjs/toolkit";
import config from "../../config";
import axiosClient from "../../common/api/request";

// The chat surface reacts to the status as well as the body: 403 hides the
// composer, 404 closes the tab, 502 keeps the typed text. Carry it alongside
// the server's own fields rather than swallowing it.
const toRejectedPayload = (error) => {
  const data = error.response?.data;
  const base =
    data && typeof data === "object" && !Array.isArray(data)
      ? data
      : { Error: data || error.message };
  return { ...base, status: error.response?.status };
};

export const getOrderMessages = createAsyncThunk(
  "get_order_messages",
  async (orderId, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/orders/${orderId}/messages/`
      );
      return data;
    } catch (error) {
      return rejectWithValue(toRejectedPayload(error));
    }
  }
);

// Read is per organization, so this clears the badge for the whole shop. The
// slice clears its own copy without waiting for the response — a failure here
// only means the next list refetch brings the count back.
export const markOrderMessagesRead = createAsyncThunk(
  "mark_order_messages_read",
  async ({ orderId, upToId }, { rejectWithValue }) => {
    try {
      const data = await axiosClient.post(
        `${config.API_URL}/orders/${orderId}/messages/read/`,
        upToId ? { up_to_id: upToId } : {}
      );
      return { orderId, ...(data || {}) };
    } catch (error) {
      return rejectWithValue(toRejectedPayload(error));
    }
  }
);

export const sendOrderMessage = createAsyncThunk(
  "send_order_message",
  async ({ orderId, message }, { rejectWithValue }) => {
    try {
      const data = await axiosClient.post(
        `${config.API_URL}/orders/${orderId}/messages/`,
        { message }
      );
      return data;
    } catch (error) {
      return rejectWithValue(toRejectedPayload(error));
    }
  }
);
